import styled from "styled-components";
import { CustomText, InputLabel } from "./reusableStyles";
import ReactQuill from "react-quill";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    [{ color: [] }, { background: [] }],
  ],
};
const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "color",
  "background",
  "clean",
];

const StyledReactQuill = styled(ReactQuill)`
  margin-top: 8px;
  .ql-editor {
    color: #101828;
    background-color: transparent;
    min-height: ${({ height }) => (height ? height : "150px")};
    max-height: ${({ height }) => (height ? height : "150px")};
  }
`;

function TextEditor({
  getTextEditorInput,
  font,
  label,
  errorText,
  height,
  disabled,
  placeholder,
  value,
}) {
  const handleChange = (content, delta, source, editor) => {
    if (source === "user") {
      getTextEditorInput(content);
    }
  };
  return (
    <div>
      <InputLabel style={{ fontFamily: font }}>{label}</InputLabel>
      {errorText && (
        <CustomText
          margin="3px 0 0 0"
          fontSize="12px"
          fontWeight="500"
          color="red"
          style={{ fontFamily: font }}
        >
          {errorText}
        </CustomText>
      )}
      <StyledReactQuill
        height={height}
        theme="snow"
        readOnly={disabled}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default TextEditor;
